define.alias("shared/errors/media-library", "calendar/errors/media-library");